module.exports = __webpack_public_path__ + "static/media/related-parties-icon.47b6291a.svg";